module.exports = __webpack_public_path__ + "img/icon-pdf.254a3542.svg";